// removed by extract-text-webpack-plugin
module.exports = {"Construction":"Construction__Construction--328BG","Patentinfo":"Construction__Patentinfo--1j2P4","bluePrintImg":"Construction__bluePrintImg--30pdP","descriptionConstruction":"Construction__descriptionConstruction--2Iy8T","descriptionP":"Construction__descriptionP--1XkGp"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Collector/Collector Constaruction/Construction.css
// module id = 60
// module chunks = 0